import Close from '@nerdwallet/react-icon/nerdwallet-ui/Close';
import styles from './CloseButton.module.less';

interface Props {
  onClick: (e) => void;
}

const CloseButton: React.FC<Props> = ({ onClick }) => {
  return (
    <button
      type="button"
      className={styles.closeButton}
      tabIndex={0}
      aria-label="Close"
      onClick={onClick}
    >
      <Close size="medium" />
    </button>
  );
};

export default CloseButton;
